import React, { useEffect, useState } from "react";
import Styles from "./Navbar.module.scss";
import styled from "./Modal.module.scss";
import { BellOutlined, SyncOutlined } from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import User from "./User/User.component";
import { logOut } from "../../redux/user/actions/user.actions";
import { useDispatch } from "react-redux";
import { ConfirmationModal } from "../Modal/ConfirmationModal";
import dateFormat from "../../helper/DateFormatter";
import { BsClockHistory } from "react-icons/bs";
import Notification from "./notification/Notification";

const Navbar = ({ title, url }) => {
  // const [openModal, setopenModal] = useState(false);
  // const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  let userDetails;
  if (localStorage.getItem("userDetails")) {
    userDetails = JSON.parse(localStorage.getItem("userDetails"));
  }

  useEffect(() => {
    if (!userDetails) {
      navigate(`/login`);
    }
  }, []);

  // const notifications = [
  //   {
  //     id: "1",
  //     title: "Hello",
  //     subTitle: "This is a sample message",
  //     unread: true,
  //     status: "0",
  //   },
  //   {
  //     id: "2",
  //     title: "Hello",
  //     subTitle: "This is a sample message",
  //     unread: false,
  //     status: "1",
  //   },
  //   {
  //     id: "3",
  //     title: "Hi",
  //     subTitle: "Another sample message",
  //     unread: true,
  //     status: "1",
  //   },
  // ];
  // const totalNot = notifications.length;

  return (
    <div className={Styles.navbarCont}>
      <div className={Styles.navbarContInner}>
        <div className={Styles.dashboardName}>
          <p className={`${Styles.dashboardName} d-none d-md-block`}>
            {title || ""}
          </p>
        </div>
        {/* <div style={{ display: "flex", alignItems: "center" }}>
          <div
            className={Styles.navContentLeft}
            onClick={() => setopenModal(true)}
          >
            <div className={Styles.navContentLeftIcons}>
              {notifications?.length > 0 ? (
                <BellOutlined spin style={{ color: "white", fontSize: 28 }} />
              ) : (
                <BellOutlined style={{ color: "white", fontSize: 28 }} />
              )}
              <div className={Styles.count}>{totalNot || 0}</div>
            </div>
          </div> */}
        <div className={Styles.dashboardName}>
          <User
            username={userDetails?.data?.name}
            onClick={() => dispatch(logOut())}
          />
        </div>
        {/* </div> */}
      </div>

      {/* DIALOG MODAL */}
      {/* <ConfirmationModal
        open={openModal}
        handleClose={() => setopenModal(false)}
        bgcolor="background.paper"
        width="30%"
        closemodal={() => setopenModal(false)}
        // instruction={
        //   notifications?.length > 0 ? (
        //     // <>
        //     //   <div className={styled.title}>NOTIFICATION(S)</div>
        //     //   {loading && <SyncOutlined spin />}
        //     //   {notifications
        //     //     ?.sort((a, b) => (a.id > b.id ? -1 : 1))
        //     //     ?.map((n) => (
        //     //       <div className={styled.container} key={n?.id}>
        //     //         <div className={styled.icon}>
        //     //           <BellOutlined style={{ color: "brown", fontSize: 28 }} />
        //     //         </div>
        //     //         <p className={styled.text}>
        //     //           A new{" "}
        //     //           <span className={styled.ordertype}>{n?.ordertype}</span>{" "}
        //     //           Order from {n?.channel}
        //     //         </p>
        //     //         <div className={styled.time}>
        //     //           <span>
        //     //             <BsClockHistory
        //     //               size={25}
        //     //               color="brown"
        //     //               className="me-3"
        //     //             />
        //     //           </span>
        //     //           <p className={styled.timeText}>
        //     //             {dateFormat.TimeAgo(n?.tym)}
        //     //           </p>
        //     //         </div>
        //     //         <div
        //     //           className={styled.btn}
        //     //           // onClick={() => viewOrder(n?.id)}
        //     //         >
        //     //           View
        //     //         </div>
        //     //       </div>
        //     //     ))}
        //     // </>
        //     <Notification data={notifications} />
        //     ) : (
        //       <>
        //       <p className={styled.notification}>
        //         You don't have new notifications
        //       </p>
        //     </>
        //   )
        // }
        instruction={<Notification data={notifications} />}
      /> */}
    </div>
  );
};

export default Navbar;
